function Strike({ strikeClass }) {
  return <div className={`strike ${strikeClass}`}></div>;
}

export default Strike;
